/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Smartphone.
 */
export const ICON_SMARTPHONE = (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.3334 0.673659L4.66671 0.666992C3.93337 0.666992 3.33337 1.26699 3.33337 2.00033V14.0003C3.33337 14.7337 3.93337 15.3337 4.66671 15.3337H11.3334C12.0667 15.3337 12.6667 14.7337 12.6667 14.0003V2.00033C12.6667 1.26699 12.0667 0.673659 11.3334 0.673659ZM11.3334 12.667H4.66671V3.33366H11.3334V12.667Z"
      fill="#4F4F4F"
    />
  </svg>
);
